import isEqual from 'lodash/isEqual';
export const isValidRateType = (rate) => /^[A-Za-z0-9_]+$/.test(rate);
export const haveErrorsFilter = (v) => v.errors.length > 0;
export const stringNotEmptyFilter = (v) => v && v.length > 0;
export const isNegativeRate = (rate) => /^-\d+(\.\d+)?$/g.test(rate);
export const dataIsUnchangedFilter = (originalData, uploadedData) => {
    return isEqual(originalData, uploadedData);
};
